import React from 'react';

interface ComingSoonCardProps {
    name: string;
    description: string;
    icon: string;
    iconAlt: string;
    hoverColor: string;
}

export const ComingSoonCard: React.FC<ComingSoonCardProps> = ({
                                                                  name,
                                                                  description,
                                                                  icon,
                                                                  iconAlt,
                                                                  hoverColor
                                                              }) => {
    return (
        <div
            className="group relative p-6 rounded-2xl bg-[#1a1a1a] border border-gray-700 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 w-full h-full"
            style={{
                borderColor: '#374151',
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100%'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = `${hoverColor}50`;
                e.currentTarget.style.boxShadow = `0 20px 25px -5px ${hoverColor}10, 0 10px 10px -5px ${hoverColor}10`;
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#374151';
                e.currentTarget.style.boxShadow = '';
            }}
        >
            {/* Content section - grows to fill space */}
            <div className="flex flex-col items-center text-center" style={{ flex: '1 1 auto' }}>
                <div className="p-3 mb-4 group-hover:scale-110 transition-transform duration-300 flex items-center justify-center">
                    <img
                        src={icon}
                        alt={iconAlt}
                        className="w-12 h-12"
                    />
                </div>
                <h3 className="text-lg font-bold text-white mb-2">
                    {name}
                </h3>
                <p className="text-sm text-gray-300 line-clamp-3 mb-4">
                    {description}
                </p>
            </div>

            {/* Button section - stays at bottom and centered */}
            <div
                className="pt-2"
                style={{
                    flex: '0 0 auto',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%'
                }}
            >
                <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold bg-gray-600 text-gray-400">
                    Coming Soon
                </span>
            </div>
        </div>
    );
};